import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ClipboardCheck } from 'lucide-react';
import { toast } from 'sonner';
import { useAuth } from '../contexts/AuthContext';
import { PROFILE_GATE_BAND, profileGateRequired } from '../lib/profileGate';

// A5b: profil tamamlatma kapısı açıkken profil sayfasının üstündeki sade bant.
export default function ProfileGateBand() {
  return <div className="home-notice dna-band profile-gate-band" role="status" data-testid="profile-gate-band">
    <ClipboardCheck size={18} aria-hidden="true" />
    <p>{PROFILE_GATE_BAND}</p>
  </div>;
}

// Gönderim/kayıttan sonra kapı durumu sunucudan tazelenir; kapı kalktıysa kullanıcı ana sayfaya döner.
export function useProfileGate() {
  const auth = useAuth();
  const navigate = useNavigate();
  const required = profileGateRequired(auth.user);
  const afterSave = async (gate) => {
    let next = gate;
    if (next && typeof next === 'object') auth.applyProfileGate?.(next);
    else next = await auth.refreshProfileGate?.();
    if (required && next && next.required === false) {
      toast.success(next.pending_review ? 'Teşekkürler! Bilgilerin incelemede; onaylanınca profilin keşifte görünür.' : 'Profilin tamamlandı.');
      navigate('/', { replace: true });
    }
  };
  return { required, afterSave };
}
